//GeneratorFlag:[NoChange]
import LetterTag from './letter-tag';
import LetterTagFilter from './letter-tag-filter';

export default {LetterTag, LetterTagFilter}
export{LetterTag, LetterTagFilter}